export default __webpack_public_path__ + "static/media/img--LUX-flexi-1.ae4ceca7.jpg";